import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { toast } from 'ngx-sonner';
import { SnackbarComponent } from 'shared/ui-common';

import { InsightsService } from './insights.service';

type TranslationParams = { [key: string]: string | number };

export type ToastOverrides = {
  duration?: number;
};

@Injectable({ providedIn: 'root' })
export class MessagesService {
  private insights = inject(InsightsService);

  private openSnackBar(
    message: string,
    translationParams: TranslationParams,
    isError?: boolean,
    overrides?: Partial<ToastOverrides>,
  ): void {
    if (isError) {
      toast.error(SnackbarComponent, { duration: 3000, componentProps: { message, translationParams }, ...overrides });
    } else {
      toast(SnackbarComponent, { duration: 3000, componentProps: { message, translationParams }, ...overrides });
    }
  }

  public showError(
    message = 'UnknownErrorPleaseTryAgainLater',
    error?: Error,
    translationParams?: TranslationParams,
    overrides?: Partial<ToastOverrides>,
  ): void {
    console.error(error);

    this.openSnackBar(message, translationParams, true, overrides);
    this.trackShownError(message, error);
  }

  // Report every error toast, so errors users see are visible in Application Insights
  private trackShownError(message: string, error?: Error): void {
    let details = '';
    if (error instanceof HttpErrorResponse) {
      // Path only: query strings can contain user input such as search texts
      const path = error.url ? new URL(error.url, window.location.origin).pathname : 'unknown url';
      details = ` (HTTP ${error.status} ${path})`;
    } else if (error?.message) {
      details = ` (${error.message})`;
    }

    this.insights.trackError(`Error message shown: ${message}${details}`);
  }

  public showInfo(info: string, translationParams?: TranslationParams, overrides?: Partial<ToastOverrides>): void {
    this.openSnackBar(info, translationParams, false, overrides);
  }
}
